import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import IdleTimeout from "@/components/IdleTimeout";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="h-screen flex items-center justify-center bg-white">
        <div className="text-equipr-black font-semibold animate-pulse" data-testid="auth-loading">
          Loading…
        </div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return (
    <>
      {children}
      <IdleTimeout />
    </>
  );
}
